'use client'

import Image from 'next/image'

// 画像アセット
import { FadeUp } from '@/components/ui/fade-up'
const imgKvMini2 = "/images/digital-pride/kv-hero.webp"
const imgKvMini1 = "/images/digital-pride/kv-mask.svg"

export function DigitalPrideContent() {
  return (
    <>
      {/* Hero Section - Figmaから正確に取得 */}
      <section className="relative overflow-hidden">
        {/* 3D空間画像 */}
        <div className="relative">
          <div
            className="h-[500px] md:h-[950px] w-full relative"
            style={{
              maskImage: `url('${imgKvMini1}')`,
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'cover'
            }}
          >
            <Image
              alt="Digital Pride Hiroshima 3D Space"
              fill
              className="object-cover"
              src={imgKvMini2}
              priority
              fetchPriority="high"
            />
          </div>

          {/* ナビゲーション - オーバーレイ */}
          <nav className="absolute top-0 right-0 z-20 hidden md:flex items-center gap-8 p-8">
            <a href="#about" className="text-sm text-[#292623] hover:opacity-70 transition font-['Montserrat',_sans-serif]">ABOUT</a>
            <a href="#functions" className="text-sm text-[#292623] hover:opacity-70 transition font-['Montserrat',_sans-serif]">FUNCTIONS</a>
            <a href="#access" className="text-sm text-[#292623] hover:opacity-70 transition font-['Montserrat',_sans-serif]">ACCESS</a>
          </nav>

          {/* ロゴ - 左上オーバーレイ */}
          <div className="absolute left-[23px] top-[14px] z-20 w-[71px] h-[53px]">
            <Image alt="d|p logo" fill className="object-contain" src="/images/digital-pride/logo.svg" />
          </div>

          {/* 左側のテキストオーバーレイ
              vinext の <Image> は SVG にも srcset="...svg 300w" を出してしまい、
              browser の natural-size 計算が SVG の path bbox (実測 657×3532) を採用して
              親 width:auto が巨大化する。Next 15 と同じ振る舞いにするため raw <img> を使う。 */}
          <div className="absolute left-4 md:left-[256px] top-[100px] md:top-[200px] z-10 w-[60px] md:w-auto h-auto">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/images/digital-pride/digital-power.svg"
              alt="地域文化をデジタルの力で成長力に変えるDX推進拠点"
              width={300}
              height={200}
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* 下部のコンテンツエリア */}
        <div className="bg-[#BEB0A8] px-4 md:px-16 py-10 md:py-20 relative">
          {/* digital pride hiroshima ロゴ */}
          <div
            className="mb-20 ml-0 max-w-full overflow-hidden"
          >
            <Image
              src="/images/digital-pride/digital-pride-hiroshima.svg"
              alt="digital pride Hiroshima"
              width={1668}
              height={200}
              className="w-full max-w-full h-auto"
            />
          </div>

          {/* CONCEPT - キャッチコピーと説明文 */}
          <div
            className="container mt-20"
          >
            {/* キャッチコピー */}
            <div
              className="font-['Shippori_Mincho_B1',_serif] leading-[40px] md:leading-[93px] text-[28px] md:text-[60px] text-[#292623] tracking-[2px] md:tracking-[6px] whitespace-pre-wrap font-bold mb-8 md:mb-16 text-center"
            >
              <p className="mb-0">地域文化をデジタルの力で</p>
              <p className="mb-0">成長力に変えるDX推進拠点、</p>
              <p>広島から始動。</p>
            </div>

            {/* 説明文 */}
            <div
              className="font-['Noto_Sans_JP',_sans-serif] font-medium leading-[28px] md:leading-[38px] text-[14px] md:text-[18px] text-[#292623] tracking-[1px] md:tracking-[2.268px] max-w-[800px] mx-auto text-center px-4"
            >
              <p className="mb-0">私たちの街や会社から、固有の「彩り」や「物語」が失われていないでしょうか。</p>
              <p className="mb-0">効率化と画一化の大きな波は、私たちを、</p>
              <p className="mb-0">誰かの決めたルールの上で競争する存在へと変えてきました。</p>
              <p className="mb-0">&nbsp;</p>
              <p className="mb-0">&nbsp;</p>
              <p className="mb-0">私たちは、その流れに「否」を突きつけます。</p>
              <p className="mb-0">&nbsp;</p>
              <p className="mb-0">CodeFoxが提唱するのは「エンジニアリング＝文化翻訳」。</p>
              <p className="mb-0">それは、地域の文化や企業の誇りを、単に守るのではなく、未来の成長力へと転換する思想です。</p>
              <p className="mb-0">AIという新しいペンを手にした今、私たちは、</p>
              <p className="mb-0">自分たちだけの物語を、自分たちの手で描くことができます。</p>
              <p className="mb-0">&nbsp;</p>
              <p>Digital Pride Hiroshimaは、その思想を「見える・触れる・動かせる」形で社会に開き、地域で挑戦するすべての人が、自らの物語の主人公となることを可能にするための拠点です。</p>
            </div>
          </div>

          {/* Entrance Image */}
          <div
            className="animate-fade-up mt-20"
           style={{ animationDelay: '0.5s', animationFillMode: 'backwards' }}>
            <Image
              src="/images/digital-pride/entrance.webp"
              alt="Digital Pride Hiroshima Entrance"
              width={1920}
              height={1080}
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* ABOUT Section */}
      <section id="about" className="bg-[#BEB0A8] py-12 md:py-24">
        <div className="container px-4">
          <h2 className="font-['Montserrat',_sans-serif] font-semibold text-[32px] md:text-[46px] text-[#292623] tracking-[-0.92px] mb-8 md:mb-16 md:ml-[116.5px]">
            ABOUT
          </h2>

          <div className="mb-12 md:mb-20 max-w-full overflow-hidden">
            <Image
              src="/images/digital-pride/dx3.svg"
              alt="DX推進の3つの柱"
              width={1200}
              height={400}
              className="w-full max-w-full md:max-w-[80%] h-auto mx-auto"
            />
          </div>

          <div className="space-y-16 md:space-y-32 mt-12 md:mt-20">
            {/* Item 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
              <div className="relative h-[300px] md:h-[575px]">
                <div
                  className="absolute inset-0"
                  style={{
                    maskImage: `url('/images/digital-pride/about-mask-1.svg')`,
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain'
                  }}
                >
                  <Image
                    alt="Digital Pride Interior 1"
                    fill
                    className="object-cover"
                    src="/images/digital-pride/about-img-1.webp"
                  />
                </div>
              </div>
              <div className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[36px] md:leading-[60px] text-[24px] md:text-[36px] text-[#292623] tracking-[2px] md:tracking-[3.6px]">
                <p className="mb-0">画一的なシステム導入による</p>
                <p>「文化が失われるDX」からの脱却</p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
              <div className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[36px] md:leading-[60px] text-[24px] md:text-[36px] text-[#292623] tracking-[2px] md:tracking-[3.6px] md:order-1 order-2">
                <p className="mb-0">地域の文化やアイデンティティを</p>
                <p>成長力に変えるDX実証</p>
              </div>
              <div className="relative h-[300px] md:h-[346px] md:order-2 order-1">
                <div
                  className="absolute inset-0"
                  style={{
                    maskImage: `url('/images/digital-pride/about-mask-2.svg')`,
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain'
                  }}
                >
                  <Image
                    alt="Digital Pride Interior 2"
                    fill
                    className="object-cover"
                    src="/images/digital-pride/about-img-2.webp"
                  />
                </div>
              </div>
            </div>

            {/* Item 3 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
              <div className="relative h-[300px] md:h-[432px]">
                <div
                  className="absolute inset-0"
                  style={{
                    maskImage: `url('/images/digital-pride/about-mask-3.svg')`,
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain'
                  }}
                >
                  <Image
                    alt="Digital Pride Interior 3"
                    fill
                    className="object-cover"
                    src="/images/digital-pride/about-img-3.webp"
                  />
                </div>
              </div>
              <div className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[36px] md:leading-[60px] text-[24px] md:text-[36px] text-[#292623] tracking-[2px] md:tracking-[3.6px]">
                <p className="mb-0">思想を「見える・触れる・</p>
                <p>動かせる」形で社会に開く拠点</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FUNCTION Section */}
      <section id="functions" className="bg-[#BEB0A8] py-12 md:py-24">
        <div className="container px-4">
          <h2 className="font-['Montserrat',_sans-serif] font-semibold text-[32px] md:text-[46px] text-[#292623] tracking-[-0.92px] mb-8 md:mb-16 md:ml-[116.5px]">
            FUNCTIONS
          </h2>

          <div className="space-y-12 md:space-y-24 md:ml-[116.5px]">
            {/* 01 */}
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-32">
              <div className="max-w-[600px]">
                <p className="font-['Montserrat',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px]">01</p>
                <div className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[32px] md:leading-[46px] text-[20px] md:text-[30px] text-[#292623] tracking-[2px] md:tracking-[3px] mt-0">
                  <p className="mb-0">地域独自のDXモデル確立に</p>
                  <p>よる競争力強化</p>
                </div>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold text-[#292623] text-[18px] md:text-[24px] mt-[75px]">実証ラボ</p>
                <div className="font-['Noto_Sans_JP',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px] mt-[12px]">
                  <p className="mb-0">・文化翻訳型DXのオリジナル開発</p>
                  <p className="mb-0">・実際の開発・検証・展示機能</p>
                  <p>・来訪者が直接体験できる展示併設</p>
                </div>
              </div>
              <div className="relative w-full md:w-[450px] h-auto md:h-[222px] flex-shrink-0 mx-auto md:mx-0">
                <Image src="/images/digital-pride/func-01.svg" alt="" width={450} height={222} className="w-full h-auto" />
              </div>
            </div>

            {/* 02 */}
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-32">
              <div className="max-w-[600px]">
                <p className="font-['Montserrat',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px]">02</p>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[46px] text-[#292623] text-[30px] tracking-[3px] mt-0">地域人材の育成と雇用創出</p>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold text-[#292623] text-[18px] md:text-[24px] mt-[52px]">「文化翻訳を担う人材」の育成</p>
                <div className="font-['Noto_Sans_JP',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px] mt-[12px]">
                  <p className="mb-0">・AI駆動開発・地域DX実務スキル研修</p>
                  <p className="mb-0">・企業からの教育出向受け入れ</p>
                  <p>・実案件を教材にした実践型プログラム</p>
                </div>
              </div>
              <div className="relative w-full md:w-[450px] h-auto md:h-[222px] flex-shrink-0 mx-auto md:mx-0">
                <Image src="/images/digital-pride/func-02.svg" alt="" width={450} height={222} className="w-full h-auto" />
              </div>
            </div>

            {/* 03 */}
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-32">
              <div className="max-w-[600px]">
                <p className="font-['Montserrat',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px]">03</p>
                <div className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[32px] md:leading-[46px] text-[20px] md:text-[30px] text-[#292623] tracking-[2px] md:tracking-[3px] mt-0">
                  <p className="mb-0">文化と技術の融合による</p>
                  <p>新たな価値創造</p>
                </div>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold text-[#292623] text-[18px] md:text-[24px] mt-[29px]">共創スペース</p>
                <div className="font-['Noto_Sans_JP',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px] mt-[12px]">
                  <p className="mb-0">・地域企業・行政・金融機関・教育機関との協働</p>
                  <p className="mb-0">・共助型地域DXのワークショップ</p>
                  <p>・ハッカソン等のイベント開催</p>
                </div>
              </div>
              <div className="relative w-full md:w-[450px] h-auto md:h-[222px] flex-shrink-0 mx-auto md:mx-0">
                <Image src="/images/digital-pride/func-03.svg" alt="" width={450} height={222} className="w-full h-auto" />
              </div>
            </div>

            {/* 04 */}
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-32">
              <div className="max-w-[600px]">
                <p className="font-['Montserrat',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px]">04</p>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold leading-[46px] text-[#292623] text-[30px] tracking-[3px] mt-0">広島発のDXモデル全国展開</p>
                <p className="font-['Shippori_Mincho_B1',_serif] font-bold text-[#292623] text-[18px] md:text-[24px] mt-[29px]">発信拠点</p>
                <div className="font-['Noto_Sans_JP',_sans-serif] font-medium leading-[30px] text-[#292623] text-[16px] tracking-[1.28px] mt-[12px]">
                  <p className="mb-0">・成果事例を「広島モデル」として発信</p>
                  <p className="mb-0">・国内外への情報発信</p>
                  <p>・島根・岡山など近隣地域への横展開予定</p>
                </div>
              </div>
              <div className="relative w-full md:w-[450px] h-auto md:h-[222px] flex-shrink-0 mx-auto md:mx-0">
                <Image src="/images/digital-pride/func-04.svg" alt="" width={450} height={222} className="w-full h-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ACCESS Section */}
      <section id="access" className="bg-[#BEB0A8] py-12 md:py-24">
        <div className="container px-4">
          <h2 className="font-['Montserrat',_sans-serif] font-semibold text-[32px] md:text-[46px] text-[#292623] tracking-[-0.92px] mb-8 md:mb-16 md:ml-[116.5px]">
            ACCESS
          </h2>

          <div className="flex flex-col md:flex-row gap-12 md:gap-20 md:ml-[116.5px]">
            {/* Left Content */}
            <div className="max-w-[600px] space-y-8">
              {/* Address */}
              <div className="font-['Noto_Sans_JP',_sans-serif] font-medium text-[18px] text-[#292623]">
                <p className="leading-[27px] mb-0">〒730-0053</p>
                <p className="leading-[27px]">広島県広島市中区東千田町１丁目１−６１</p>
              </div>

              {/* Google Map Link */}
              <a
                href="https://maps.app.goo.gl/LYEKFsvBicHnrfth7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block font-['Noto_Sans_JP',_sans-serif] font-medium text-[18px] text-[#292623] underline"
              >
                Google Map
              </a>

              {/* Transportation Info */}
              <div className="space-y-8 pt-4">
                {/* 電車 */}
                <div>
                  <p className="font-['Noto_Sans_JP',_sans-serif] font-semibold text-[18px] text-[#292623] mb-1">
                    電車
                  </p>
                  <div className="bg-[#a8958a] h-px w-full md:w-[420px] mb-2" />
                  <div className="font-['Noto_Sans_JP',_sans-serif] font-medium text-[18px] text-[#292623] leading-[30px]">
                    <p className="mb-0">広島電鉄宇品線「日赤病院前」駅から</p>
                    <p>徒歩約6～8分程度</p>
                  </div>
                </div>

                {/* バス */}
                <div>
                  <p className="font-['Noto_Sans_JP',_sans-serif] font-semibold text-[18px] text-[#292623] mb-1">
                    バス
                  </p>
                  <div className="bg-[#a8958a] h-px w-full md:w-[420px] mb-2" />
                  <div className="font-['Noto_Sans_JP',_sans-serif] font-medium text-[18px] text-[#292623] leading-[30px]">
                    <p className="mb-0">広島交通バス「日赤病院前」バス停から</p>
                    <p>徒歩約3～4分</p>
                  </div>
                </div>

                {/* 自家用車 */}
                <div>
                  <p className="font-['Noto_Sans_JP',_sans-serif] font-semibold text-[18px] text-[#292623] mb-1">
                    自家用車
                  </p>
                  <div className="bg-[#a8958a] h-px w-full md:w-[420px] mb-2" />
                  <p className="font-['Noto_Sans_JP',_sans-serif] font-medium text-[18px] text-[#292623] leading-[30px]">
                    東千田公園に隣接するアルク東千田店の駐車場のご利用を推奨
                  </p>
                </div>
              </div>
            </div>

            {/* Right Content - Map */}
            <div className="w-full md:w-[660px] flex-shrink-0">
              <Image
                src="/images/digital-pride/map.svg"
                alt="Digital Pride Hiroshima Map"
                width={660}
                height={500}
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - 1時間無料相談 */}
      <section className="py-16 md:py-24 bg-[#292623]">
        <div className="container px-4">
          <FadeUp
            className="max-w-3xl mx-auto text-center"
          >
            <h2 className="font-['Shippori_Mincho_B1',_serif] text-[32px] md:text-[46px] font-bold text-white mb-6">
              DXの悩み、お聞かせください
            </h2>
            <p className="font-['Noto_Sans_JP',_sans-serif] text-[16px] md:text-[18px] text-white/80 mb-8">
              あなたの地域や企業の「らしさ」を、成長力に変えるDXを。<br />
              まずは1時間、お話を聞かせてください。
            </p>
            <a
              href="/contact?type=consultation"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#292623] rounded-md font-['Noto_Sans_JP',_sans-serif] font-semibold text-lg hover:bg-white/90 transition-colors"
            >
              1時間無料相談を申し込む
            </a>
          </FadeUp>
        </div>
      </section>
    </>
  )
}
